import { Modal } from '@/components/Modal'
import { Button } from '@/components/Button'

interface ApplyInterstitialModalProps {
	open: boolean
	onClose: () => void
	onContinue: () => void
	/** CMS WYSIWYG (HTML) message shown before forwarding to the apply URL. */
	content: string
}

export function ApplyInterstitialModal ({
	open,
	onClose,
	onContinue,
	content
}: ApplyInterstitialModalProps) {
	return (
		<Modal
			open={open}
			onClose={onClose}
			title='Apply'
			fitContent
			spacesClass='spaces-apply-interstitial'
		>
			<div className='spaces:flex spaces:flex-col spaces:gap-24'>
				{content && (
					<div
						className='spaces-apply-interstitial-content spaces:flex spaces:flex-col spaces:gap-12 spaces:text-16/24 spaces:font-default spaces:text-content-2'
						dangerouslySetInnerHTML={{ __html: content }}
					/>
				)}
				<Button
					label='Continue'
					appearance='solid'
					color='brand'
					size='lg'
					spacesClass='spaces-apply-interstitial-confirm'
					onClick={onContinue}
					className='spaces:w-full'
				/>
			</div>
		</Modal>
	)
}
